import React, { useEffect, useState } from "react";
import sort from "../../icons/sort.svg";
import yearsData from "../../static/year.json";
import { Collapse, Select } from "antd";
import { getProducts } from "../../service/api";
import { useQuery } from "@tanstack/react-query";
import { customFilterVisits } from "../../service/api";
import moment from "jalali-moment";

function CustomFilter({ states, setVisitData,setLoading }) {
  const productsQuery = useQuery(["products"], getProducts);
  const [yearsNumber, setYearsNumber] = useState([]);
  const [products, setProducts] = useState([]);
  const [state, setState] = useState([]);
  const [productId, setProductId] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [yearValue, setYearValue] = useState(null);

  

  useEffect(() => {
    if (productsQuery?.data && states) {
      let year = yearsData?.year?.map((year) => {
        return { label: year?.year, value: year?.value };
      });
      setYearsNumber(year);

      let productData = productsQuery?.data?.map((item) => {
        return { label: item.persianName, value: item.pid };
      });

      setProducts(productData);
    }
    //
    let stateData = states?.map((item) => {
      return { label: item.name, value: item.id };
    });
    setState(stateData);
  }, [productsQuery?.data, states]);

  const items = [
    {
      key: 2,
      label: (
        <section className="flex flex-row  whitespace-nowrap">
          <img alt="filter" src={sort} />
          <p>فیلتر ها براساس:</p>
        </section>
      ),
      children: (
        <div className="flex flex-col gap-3 m-[-16px] p-3 rounded-b-lg bg-[#C7E7E5]">
          <Select allowClear  onChange={(e) => setYearValue(e)} options={yearsNumber} placeholder="سال" />
          <Select
          allowClear
            onChange={(e) => setProductId(e)}
            options={products}
            placeholder="کشت"
          />
          <Select
          allowClear
            onChange={(e) => setStateId(e)}
            options={state}
            placeholder="وضعیت"
          />
        </div>
      ),
    },
  ];

  const visitsQuery = useQuery(
    ["visits", productId, yearValue, stateId],
    () => customFilterVisits(productId, yearValue, stateId)

  );

  useEffect(() => {
    if (visitsQuery.isLoading) {
      setLoading(true);
    }
    if (visitsQuery.isFetched) {
      setLoading(false);
    }
    if (visitsQuery?.data) {
      const visitsData =
      visitsQuery?.data?.result?.data?.Visits.map((data) => {
          return {
            // key:1,
            name: data?.farmer?.firstName + " " + data?.farmer?.lastName,
            product: data?.product?.persianName,
            area: data?.area + " هکتار  ",
            date: moment(data?.createdAt, "YYYY/MM/DD")
              .locale("fa")
              .format("YYYY/MM/DD"),
            location: data?.city,
            state: data,
            operation: data,
          };
        });

      setVisitData(visitsData);
    }
  }, [visitsQuery?.data,setVisitData]);

  return (
    <div className="flex flex-row font-body bg-[#C7E7E5] p-3 max-lg:p-0 items-center justify-between rounded-xl max-lg:bg-white">
      <Collapse
        className="hidden max-lg:block w-full bg-[#C7E7E5]"
        accordion={true}
        items={items}
        expandIconPosition="end"
      />
      <section className="flex flex-row whitespace-nowrap max-lg:hidden">
        <img alt="filter" src={sort} />
        <p>فیلتر ها براساس:</p>
      </section>

      <Select
        allowClear
        onChange={(e) => setYearValue(e)}
        options={yearsNumber}
        className="w-1/4 max-lg:hidden"
        placeholder="سال"
      />
      <Select
        allowClear
        options={products}
        className="w-1/4 max-lg:hidden"
        placeholder="کشت"
        onChange={(e) => setProductId(e)}
      />
      <Select
        allowClear
        onChange={(e) => setStateId(e)}
        options={state}
        className="w-1/4 max-lg:hidden"
        placeholder="وضعیت"
      />
    </div>
  );
}

export default CustomFilter;
